module.exports = __webpack_public_path__ + "static/media/expanding-review-box.fddf827d.png";